import { useMutation } from '@tanstack/react-query';
import { del } from '@truefit/http-utils';
import getCurrentUser from '../user/getCurrentUser';

const useDeleteOrgLogo = () => {
  const getCurrentUserQuery = getCurrentUser();
  return useMutation({
    mutationFn: async () => {
      const response = await del<{ deleted: boolean }>('/v1.0/org/logo');
      return response.data;
    },
    onSuccess: () => {
      getCurrentUserQuery.refetch();
    },
  });
};

export default useDeleteOrgLogo;
